
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: { XInput, Datetime, Checklist, XButton, Group, Checker, CheckerItem, Flexbox, FlexboxItem },
data () {
return {

caseListType: this.$route.params.caselistype,
caseTypeList: [
{value: '3', text: '快速病例'},
{value: '1', text: '细胞病例'},
{value: '2', text: '组织病例'}
],
patName: '',
patHology: '',
startDate: '',
endDate: '',
searchCaseType: ['1', '2']
}
},
methods: {

search () {

let params = new Map()
params.set('patName', this.patName)
params.set('patHology', this.patHology)
params.set('startDate', this.startDate)
params.set('endDate', this.endDate)
params.set('searchCaseType', this.searchCaseType)

if (this.caseListType === '1') {
this.$router.push({name: 'DzdCaseList', params: {searchCondition: params}})
} else if (this.caseListType === '2') {
this.$router.push({name: 'YzdCaseList', params: {searchCondition: params}})
} else {
this.$router.push({name: 'MedicalUnionList', params: {searchCondition: params}})
}
},

cancelSearch () {
this.$router.go(-1)
}
}
}



// WEBPACK FOOTER //
// ./src/components/base/caseSearch/caseSearch.vue